import React from "react";
import { FormattedMessage } from "react-intl";
import manage1 from "../../../../assets/mobile/manage1.png";
import manage2 from "../../../../assets/mobile/manage2.png";
import "./manage.scss";
const managesData = [
  {
    img: manage1,
    color: "var(--main-color)",
    title: <FormattedMessage id="advertiser" defaultMessage="Advertiser" />,
  },

  {
    img: manage2,
    color: "var(--second-color)",
    title: <FormattedMessage id="publisher" defaultMessage="Publisher" />,
  },
];

const Manage = () => {
  return (
    <div className="mobile-manage">
      <div className="text">
        <h1 className="mid-title">
          <FormattedMessage
            id="mobile-manage-title"
            defaultMessage="Manage your AdGate account"
          />
        </h1>
        <p className="def-text">
          <FormattedMessage
            id="mobile-manage-text"
            defaultMessage="The AdGate app offers the publishers, advertisers and agencies involved a convenient tool to keep an eye on their account while on the go and a simple way to get started with affiliate marketing."
          />
        </p>
      </div>

      <div className="flex">
        {managesData.map((props, i) => {
          return (
            <div className="manageCard" key={i}>
              <div
                className="title"
                style={{ backgroundColor: `${props.color}` }}
              >
                <h1>{props.title}</h1>
              </div>

              <div
                className="img"
                style={{ content: `url(${props.img})` }}
              ></div>

              <div
                className="triangle triangle1"
                style={{ backgroundColor: `${props.color}` }}
              />
              <div
                className="triangle triangle2"
                style={{ backgroundColor: `${props.color}` }}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Manage;
